import type { Variant } from "@app/protocol";
import { openExternal } from "../discord/handshake";
import { useT } from "../i18n/context";
import { useStore } from "../store";
import { IconButton } from "./IconButton";
import { Icon } from "./icons";

/** How each game is played, in English, on the site (review 0024 decision 174). */
export function rulesUrl(variant: Variant): string {
  return `https://highcard.club/rules/${variant}`;
}

/** The pill in the settings panel's header on the home screen; Discord asks before it opens the page. */
export function RulesText({ variant }: { variant: Variant }) {
  const { t } = useT();
  const sdk = useStore((s) => s.sdk);
  return (
    <button
      type="button"
      className="flex-none rounded-pill border-[1.5px] border-ink/30 bg-ink/6 px-4 py-2 text-[13px] font-bold text-gold hover:border-gold"
      onClick={() => void openExternal(sdk, rulesUrl(variant))}
    >
      {t("rules.how")}
    </button>
  );
}

/** The same page from the table's top bar, for a player who forgot a rule mid-game. */
export function RulesButton({ variant, size }: { variant: Variant; size: number }) {
  const { t } = useT();
  const sdk = useStore((s) => s.sdk);
  return (
    <IconButton
      label={t("rules.how")}
      size={size}
      onClick={() => void openExternal(sdk, rulesUrl(variant))}
    >
      <Icon name="help" strokeWidth={2.2} />
    </IconButton>
  );
}
